<template>
  <div>
    <baseFrame
      :showCtrls="true"
      submitText="提交"
      clearText=""
      :submitLoading="submitLoading"
      @cancel="handleToStocktakingList"
      @submit="handleSubmit">
      <div slot="content">
        <lk-card title="盘点损溢信息">
          <lk-form
            ref="formStocktakingAdjust"
            :model="stocktakingPlan"
            :rules="formRules"
            :label-width="130">
            <lk-row :gutter="16">
              <lk-col span="8">
                <lk-form-item label="盘点计划:" prop="stocktakingPlanId">
                  <lk-select
                      class="item"
                      clearable
                      v-model.trim="stocktakingPlan.stocktakingPlanId"
                      placeholder="全部"
                      @on-change="handlePlanChange"
                      @on-clear="handleClear">
                    <lk-option v-for="item in stocktakingPlanList" :key="item.id" :value="item.id">
                      {{item.name}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span="8">
                <lk-form-item label="盘点仓库:">
                  {{stocktakingPlan.warehouseNames}}
                </lk-form-item>
              </lk-col>
              <lk-col span="8">
                <lk-form-item label="盘点类型:">
                  {{stocktakingPlan.operatorType}}
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="8">
                <lk-form-item label="盘点方式:">
                  {{stocktakingPlan.operatorPattern}}
                </lk-form-item>
              </lk-col>
              <lk-col span="8">
                <lk-form-item label="是否含0在库数量商品:">
                  {{stocktakingPlan.hasZeroStr}}
                </lk-form-item>
              </lk-col>
              <lk-col span="8">
                <lk-form-item label="创建人员:">
                  {{stocktakingPlan.createUserName}}
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="8">
                <lk-form-item label="创建时间:">
                  {{stocktakingPlan.createTime}}
                </lk-form-item>
              </lk-col>
              <lk-col span="8">
                <lk-form-item label="盘点人员:">
                  {{stocktakingPlan.operatorName}}
                </lk-form-item>
              </lk-col>
              <lk-col span="8">
                <lk-form-item label="盘点时间:">
                  {{stocktakingPlan.operatorTime}}
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="8">
                <lk-form-item label="录入人员:">
                  {{stocktakingPlan.checkNames}}
                </lk-form-item>
              </lk-col>
              <lk-col span="8">
                <lk-form-item label="录入时间:">
                  {{stocktakingPlan.createTime}}
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="22">
                <!-- <lk-form-item label="商品调整信息:" class="requireStocktakingAdjust" prop="tableData">
                  <lk-table border :columns="columns" :data="stocktakingPlan.tableData"></lk-table>
                </lk-form-item> -->
                <lk-card title="盘点损溢信息">
                  <lk-table border :columns="columns" :data="stocktakingPlan.tableData" class="requireStocktakingAdjust"></lk-table>
                </lk-card>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </baseFrame>
  </div>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import inventory from '../../services/inventory';
import shareData from '../../libs/sharedDara';
import utils from '../../libs/utils';

export default {
  name: 'stocktakingProfitAndLossCreate',
  components: {
    baseFrame,
  },
  data() {
    return {
      stocktakingPlan: {
        stocktakingPlanId: null,
        warehouseNames: null,
        hasZeroStr: null,
        operatorName: null,
        createTime: null,
        applyReason: null,
        tableData: [],
      },
      formRules: {
        stocktakingPlanId: [
          {
            required: true,
            message: '请选择盘点计划',
          },
        ],
      },
      booleanList: [],
      submitLoading: false,
      stocktakingPlanList: [],
      strZeroToFixed: (0).toFixed(2),
      adjustTotalCount: 0,
      adjustTotalPrice: 0,
      statusMap: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      boolsMap: new Map([
        [1, '是'],
        [2, '否'],
      ]),
      columns: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          tooltip: true,
        },
        {
          title: '商品编码',
          key: 'drugSerialCode',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '商品名称',
          key: 'goodsName',
          minWidth: 110,
          tooltip: true,
        },
        { title: '系统冻结数量',
          key: 'breakageFrozenAmount',
          minWidth: 110,
          tooltip: true,
        },
        { title: '手动冻结数量',
          key: 'manualFrozenNum',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '可销售数量',
          key: 'inventoryCount',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '在库数量',
          key: 'inInventoryCount',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '剂型',
          key: 'dosageForm',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '单位',
          key: 'drugMiniPackageUnit',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '批号',
          key: 'goodsBatchNumber',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '商品状态',
          key: 'goodsStoreStatusStr',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '仓库',
          key: 'warehouseName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '货位',
          key: 'locationCode',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '批次',
          key: 'goodsBatchSeq',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '通用名称',
          key: 'approvedName',
          minWidth: 110,
          tooltip: true,
        },

        {
          title: '实盘库存',
          key: 'realCount',
          minWidth: 130,
          tooltip: true,
        },
        { title: '未处理损溢数量', key: 'noDealNum', minWidth: 110 },
        {
          title: '本次处理损溢数量',
          key: 'adjustCount',
          minWidth: 110,
          tooltip: true,
          fixed: 'right',
          render: (h, { row, index }) => h('lk-input-number', {
            props: {
              value: row.adjustCount,
              min: -1000000000,
              max: 1000000000,
              precision: 2,
              activeChange: false,
              placeholder: '请输入',
            },
            on: {
              'on-change': (value) => {
                row.adjustCount = value;
                setTimeout(() => {
                  this.stocktakingPlan.tableData[index].adjustCount = value;
                });
              },
            },
          }),
        },
        {
          title: '本次调整批次',
          key: 'adjustBatchSeqId',
          minWidth: 200,
          tooltip: true,
          fixed: 'right',
          render: (h, { row, index }) => {
            const options = row.inventoryInfoList.map(item => h('lk-option', {
              props: {
                value: item.id,
              }
            }, `批次  ${item.goodsBatchSeq} 可销售  ${item.goodsStockNum}`));
            return h('lk-select', {
              props: {
                value: row.adjustBatchSeqId,
                placement: 'bottom',
                transfer: true,
                clearable: true
              },
              on: {
                'on-change': (value) => {
                  let item = row.inventoryInfoList.find(item => item.id === value);
                  if (item) {
                    row.adjustBatchSeq = item.goodsBatchSeq;
                    row.adjustBatchSeqId = value;
                    item = null;
                    row.inventoryId = value;
                    setTimeout(() => {
                      this.stocktakingPlan.tableData[index].adjustBatchSeq = row.adjustBatchSeq;
                      this.stocktakingPlan.tableData[index].adjustBatchSeqId = row.adjustBatchSeqId;
                      this.stocktakingPlan.tableData[index].inventoryId = row.inventoryId;
                    });
                  }
                },
              },
            },
            options);
          }
        },
        {
          title: '是否调整库存',
          key: 'changeInventory',
          minWidth: 110,
          tooltip: true,
          fixed: 'right',
          render: (h, { row, index }) => {
            const options = shareData.booleanList.map(item => h('lk-option', {
              props: {
                value: item.id
              }
            }, item.name));
            return h('lk-select', {
              props: {
                value: row.changeInventory,
                transfer: true,
              },
              on: {
                'on-change': (value) => {
                  row.changeInventory = value;
                  setTimeout(() => {
                    this.stocktakingPlan.tableData[index].changeInventory = row.changeInventory;
                  });
                },
              },
            },
            options);
          }
        },
        {
          title: '损溢原因',
          key: 'adjustReason',
          minWidth: 110,
          tooltip: true,
          fixed: 'right',
          render: (h, { row, index }) => h('lk-input', {
            props: {
              clearable: true,
              value: row.adjustReason,
              maxlength: 50,
            },
            on: {
              'on-blur': (e) => {
                row.adjustReason = e.target.value;
                setTimeout(() => {
                  this.stocktakingPlan.tableData[index].adjustReason = row.adjustReason;
                });
              },
            },
          }),
        },
        {
          title: '操作',
          minWidth: 120,
          fixed: 'right',
          render: (h, { row, index }) => {
            return h('div', [ h('lk-button', {
              props: {
                type: 'text'
              },
              on: {
                click: () => {
                  this.stocktakingPlan.tableData.push(row);
                }
              }
            }, '复制'), h('lk-button', {
              props: {
                type: 'text'
              },
              on: {
                click: () => {
                  this.stocktakingPlan.tableData.splice(index, 1);
                }
              }
            }, '删除')])
          }
        },
      ],
    };
  },
  computed: {},
  methods: {
    getStocktakingPlans() {
      this.stocktakingPlanList = [];
      return inventory.stocktakingPlanListCondition({
        status: 6,
        hasNoDealNum: 1,
        page: 1,
        size: 1000,
      }).then((res) => {
        if (res.data.status === 200) {
          this.stocktakingPlanList = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPlanData(stocktakingPlanId) {
      inventory.editStocktakingProfitAndLoss({ stocktakingPlanId }).then((res) => {
        if (res.data.status === 200) {
          const { stocktakingPlan, stocktakingRecords } = res.data.data;
          // 盘点计划信息
          stocktakingPlan.stocktakingPlanId = stocktakingPlan.id;
          stocktakingPlan.hasZeroStr = this.boolsMap.get(stocktakingPlan.hasZero);
          stocktakingPlan.createTime = utils.exchangeTimeToSecond(stocktakingPlan.createTime);
          stocktakingPlan.operatorTime = utils.exchangeTimeToSecond(stocktakingPlan.operatorTime);
          stocktakingPlan.operatorType = shareData.operatorTypeList[stocktakingPlan.operatorType-1].name;
          stocktakingPlan.operatorPattern = shareData.operatorPatternsList[stocktakingPlan.operatorPattern-1].name;
          stocktakingPlan.checkNames = `${stocktakingPlan.firstOperatorName}-${stocktakingPlan.secondOperatorName}`;
          stocktakingPlan.tableData = [];
          this.stocktakingPlan = stocktakingPlan;
          // 商品调整信息
          let adjustTotalCount = 0;
          let adjustTotalPrice = 0;
          stocktakingRecords.forEach((item) => {
            item.stocktakingRecordId = item.id;
            item.goodsStoreStatusStr = this.statusMap.get(item.goodsStoreStatus);
            item.adjustReason = '';
            item.adjustTotalPrice = utils.addPlusPrefix(utils.toFixed2(item.priceBeforeTax * item.adjustCount));

            // 损溢合计
            adjustTotalCount += Number(item.adjustCount);
            adjustTotalPrice += Number(item.adjustTotalPrice);
          });
          this.stocktakingPlan.tableData = stocktakingRecords;
          this.adjustTotalCount = utils.addPlusPrefix(adjustTotalCount.toFixed(2));
          this.adjustTotalPrice = utils.addPlusPrefix(utils.toFixed2(adjustTotalPrice));
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleSubmit() {
      this.$refs.formStocktakingAdjust.validate((valid) => {
        if (valid) {
          let errorMsg = '';
          for (let i = 0, len = this.stocktakingPlan.tableData.length; i < len; i++) {
            const item = this.stocktakingPlan.tableData[i];
            if (item.adjustReason === '' || item.changeInventory == '' || item.adjustBatchSeq == '' || item.adjustCount === '') {
              errorMsg = '请先填写完信息';
              break;
            }
            //校验单个商品的未处理损溢数量和本次处理损溢数量，本次处理损溢量不可大于商品的未处理损溢量
            if (item.noDealNum < 0 && item.adjustCount > 0) {
              errorMsg = '未处理损溢数量为负数时，本次处理损溢数量需为负数';
              break;
            }
            if (item.noDealNum > 0 && item.adjustCount < 0) {
              errorMsg = '未处理损溢数量为正数时，本次处理损溢数量需为正数';
              break;
            }
            if (item.noDealNum > 0 && item.noDealNum < item.adjustCount ) {
              errorMsg = '单个商品的本次处理损溢量不可大于未处理损溢量';
              break;
            }
            if (item.noDealNum < 0 && item.noDealNum > item.adjustCount ) {
              errorMsg = '单个商品的本次处理损溢量不可大于未处理损溢量';
              break;
            }
            if (item.adjustCount === 0) {
              errorMsg = '本次处理损溢数量不可为0';
              break;
            }
            if (item.noDealNum < 0 && item.adjustCount > item.inventoryCount) {
              errorMsg = '本次处理损溢数量不可大于可销售数量';
              break;
            }
          }
          if (errorMsg) {
            this.$Message.error(errorMsg);
            return;
          }

          const params = {};
          params.stocktakingProfitAndLossAdjusts = this.stocktakingPlan.tableData;
          params.stocktakingProfitAndLoss = {
            stocktakingPlanId: this.stocktakingPlan.stocktakingPlanId,
            applyReason: this.stocktakingPlan.applyReason,
          };
          this.submitLoading = true;
          inventory.submitStocktakingProfitAndLossResult(params).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('提交成功');
              this.handleToStocktakingList();
            } else {
              this.$Message.error(res.data.error);
            }
            this.submitLoading = false;
          }).catch((err) => {
            this.submitLoading = false;
            utils.handleError(err);
          });
        } else {
          this.$Message.error('请按照要求填写');
        }
      });
    },
    handlePlanChange(planId) {
      if (!planId) {
        return;
      }
      this.getPlanData(planId);
    },
    handleClear() {
      this.stocktakingPlan = {};
      this.adjustTotalPrice = this.strZeroToFixed;
      this.adjustTotalCount = this.strZeroToFixed;
    },
    handleToStocktakingList() {
      this.$router.push({
        name: 'stocktakingProfitAndLoss',
      });
    },
  },
  created() {
    this.getStocktakingPlans();
    this.handleClear();
    this.booleanList = shareData.booleanList;
  },
};
</script>
<style lang="less" scoped>
</style>
